import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

var httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  private url = 'api/home';
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.url = baseUrl + this.url;
  }

  getToken(): string {
    var tokenJson = JSON.parse(localStorage.getItem('currentUser') || '');
    return tokenJson.token;
  }

  get(): Observable<any> {
    const apiurl = `${this.url}`;
    return this.http.get<any>(apiurl);
  }

  post(home: any): Observable<any> {
    const apiurl = `${this.url}`;
    return this.http.post<any>(apiurl, home, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }

  put(id: number, home: any): Observable<any> {
    const apiurl = `${this.url}/${id}`;
    return this.http.put<any>(apiurl, home, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }
}
